<template>
  <div class="col-sm-12 col-xs-12">
    <div class="panel panel-default border-panel panel-tabs card-view activity-table-panel">
      <div class="panel-heading">
        <div class="pull-left auto-width">
          <h6 class="panel-title txt-dark">{{ $t(title) }}</h6>
        </div>
        <div class="clearfix"></div>
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th style="padding-left: 0px; width: 5%">#</th>
                <th :style="'width: 51%'">{{ this.$t('app.dashboard.industry.suffix') }}</th>
                <th class="activity" style="width: 41%">{{ $t('app.dashboard.activity') }}</th>
                <th style="width: 8%">{{ $t('app.dashboard.activity') }}</th>
              </tr>
            </thead>
          </table>
        </div>

      </div>
      <div v-if="data.length > 0" class="panel-wrapper collapse in">
        <div
          :class="'panel-body pa-0  row content-row'">
          <div class="tab-content" id="myTabContent_9">
            <div id="profile_9" class="tab-pane fade active in" role="tabpanel">
              <div class="table-wrap">
                <div>
                  <table class="table table-hover mb-0">
                    <tbody>
                      <tr v-for="(partner, index) in data" :key="index">
                        <td>{{ index + 1}}</td>
                        <td style="width: 32%;">{{ partner.name }}</td>
                        <td class="chart-td">
                          <span v-if="partner.count === 0">{{ $t('app.dashboard.noData') }}</span>
                          <activity-chart v-if="partner.count > 0" :colClasses="colClass"
                            :chartStyle="'width: 100%; background: none;box-shadow: none;margin: auto;margin-left: 0; max-height: 70px; padding: 0 15px 0 15px;'"
                            :options="getChartOptions(partner)" :chartHeight="'80px'"
                            :series="getChartSeries(partner)" />
                        </td>
                        <td><span>{{ partner.count }}</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="panel-wrapper collapse in">
        <div
          :class="'panel-body pa-0  row content-row no-data'">
          <div class="tab-content" id="myTabContent_9">
            <div id="profile_9" class="tab-pane fade active in" role="tabpanel">
              <div class="table-wrap">
                <div>
                  <table class="table table-hover mb-0">
                    <tbody>
                      <tr>
                        {{ $t('app.dashboard.noData') }}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActivityChart from './ActivityChart';

export default {
  name: 'ActivityTable',
  components: {
    'activity-chart': ActivityChart,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    colClass: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  created() { },
  methods: {
    getChartOptions(partner) {
      return {
        chart: {
          animations: {
            enabled: false,
          },
          id: 'vuechart-example',
          height: '70px',
          dropShadow: {
            enabled: false,
          },
          toolbar: {
            show: true,
            tools: {
              download: false,
            },
          },
        },
        grid: {
          show: false,
        },
        xaxis: {
          categories: partner.activity.categories,
          lines: {
            show: false,
          },
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        stroke: {
          colors: ['var(--main-color)'],
        },
      };
    },
    getChartSeries(partner) {
      return [{
        name: this.$t('app.dashboard.activity'),
        data: partner.activity.series,
      }];
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-table-panel {}

.content-row {
  height: 410px;
  overflow-y: auto;
}

.chart-td {
  padding: 0 157px 0 95px !important;
}

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/ActivityTable.vue